import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ChevronIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M13.732 4l5.196-3a2 2 0 012.732.732l.5.866a2 2 0 01-.732 2.732l-5.196 3a2 2 0 01-2.732-.732l-.5-.866A2 2 0 0113.732 4zm6.196-1.268l-5.196 3 .5.866 5.196-3-.5-.866z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M22.942 8.151a1.1 1.1 0 11-1.1-1.905 1.1 1.1 0 011.1 1.905zM20.343 9.651a1.1 1.1 0 11-1.1-1.905 1.1 1.1 0 011.1 1.905zM16.243 10.749a1.1 1.1 0 101.905-1.1 1.1 1.1 0 00-1.905 1.1zM2.455 7.749a1.1 1.1 0 11-1.905-1.1 1.1 1.1 0 011.905 1.1z"
                        }),
                        _jsx("path", {
                            d: "M13.732 16l5.196-3a2 2 0 012.732.732l.5.866a2 2 0 01-.732 2.732l-5.196 3a2 2 0 01-2.732-.732l-.5-.866A2 2 0 0113.732 16zm6.196-1.268l-5.196 3 .5.866 5.196-3-.5-.866z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M18.321 21.549a1.1 1.1 0 11-1.905 1.1 1.1 1.1 0 011.905-1.1zM20.92 20.049a1.1 1.1 0 11-1.906 1.1 1.1 1.1 0 011.905-1.1zM23.115 20.051a1.1 1.1 0 10-1.1-1.905 1.1 1.1 0 001.1 1.905zM5.053 9.249a1.1 1.1 0 11-1.905-1.1 1.1 1.1 0 011.905 1.1z"
                        }),
                        _jsx("path", {
                            d: "M10.028 16l-5.196-3a2 2 0 00-2.732.732l-.5.866a2 2 0 00.732 2.732l5.196 3a2 2 0 002.732-.732l.5-.866A2 2 0 0010.028 16zm-6.196-1.268l5.196 3-.5.866-5.196-3 .5-.866z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M5.439 21.549a1.1 1.1 0 101.905 1.1 1.1 1.1 0 00-1.905-1.1zM2.84 20.049a1.1 1.1 0 101.906 1.1 1.1 1.1 0 00-1.905-1.1zM.645 20.051a1.1 1.1 0 111.1-1.905 1.1 1.1 0 01-1.1 1.905zM7.651 10.749a1.1 1.1 0 11-1.905-1.1 1.1 1.1 0 011.905 1.1z"
                        }),
                        _jsx("path", {
                            d: "M10.162 4L4.966 1a2 2 0 00-2.732.732l-.5.866a2 2 0 00.732 2.732l5.196 3a2 2 0 002.732-.732l.5-.866A2 2 0 0010.162 4zM3.966 2.732l5.196 3-.5.866-5.196-3 .5-.866z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        })
                    ]
                })
            })
        ]
    });
};
ChevronIcon.isCarinaIcon = true;
export default ChevronIcon;
